/**
 * Bill filter keys used in the frontend that map to the backend BillFilterTypes enum values.
 * These string values are used as keys to identify specific filters in the filter system.
 *
 * Backend enum reference: Global.Core/Enums/Bills/Bills.cs - BillFilterTypes
 *
 * Note: Filter keys are stored as strings in the frontend filter system, which is why
 * these enum values are strings rather than numbers.
 */
export enum BillFilterKey {
    // Bill Status filter (BillFilterTypes.Status = 0)
    Status = "0",

    // Approver filter (BillFilterTypes.Approver = 26)
    Approver = "26",

    // Awaiting Approval Only filter (BillFilterTypes.AwaitingApprovalOnly = 27)
    AwaitingApprovalOnly = "27",

    // Bill Source filter (BillFilterTypes.BillSource = 30)
    BillSource = "30",

    // Partially Paid filter (BillFilterTypes.PartiallyPaid = 32) — behind the Bill Partial Payments flag
    PartiallyPaid = "32",
}

/**
 * Bill list view types that can be used as route parameters.
 * These values correspond to the optional :view parameter in the /Bills/:view? route.
 *
 * Example usage: /app/Bills/InReview
 */
export enum BillListRouteView {
    // View bills that are in review status for the current user
    InReview = "InReview",
}
